import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { JasperoAlertsModule } from '@jaspero/ng2-alerts';
import { AlertsService } from '@jaspero/ng2-alerts';

import { NgxUiLoaderModule, NgxUiLoaderHttpModule } from  'ngx-ui-loader';

import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';

import { AppComponent } from './app.component';

import { LoginModule } from './pages/login/login.module';
import { LoginComponent } from './pages/login/login.component';

import { ComprobantesModule } from './pages/comprobantes/comprobantes.module';
import { ComprobantesComponent } from './pages/comprobantes/comprobantes.component';

// Services
import { Session } from './services/session/session.service';
import { AutoLogoutService } from './services/auth/authlogout.service';
import { Constants } from './services/constants/constants.service';
import { DataService } from './services/utils/data/data.service';
import { APRService } from './services/apr/apr.service';
import { UsuariosService } from './services/usuarios/usuarios.service';
import { SociosService } from './services/socios/socios.service';
import { CuentasService } from './services/cuentas/cuentas.service';
import { IndicadoresService } from './services/indicadores/indicadores.service';
import { RegionesService } from './services/regiones/regiones.service';
import { LecturasService } from './services/lecturas/lecturas.service';
import { PagosService } from './services/pagos/pagos.service';
import { ExternoService } from './services/externo/externo.service';
import { ModelosTarifariosService } from './services/modelostarifarios/modelostarifarios.service';
import { GruposCuentasService } from './services/gruposcuentas/gruposcuentas.service';
import { WebsocketService } from './services/websocket/websocket.service';

import { DashboardHomeComponent } from './dashboard/home/home.component';
import { DashboardAPRComponent } from './dashboard/apr/apr.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { TableListComponent } from './table-list/table-list.component';
import { TypographyComponent } from './typography/typography.component';
import { IconsComponent } from './icons/icons.component';
import { MapsComponent } from './maps/maps.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { UpgradeComponent } from './upgrade/upgrade.component';
import {
  AgmCoreModule
} from '@agm/core';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';

import { AuthGuard } from './guards/auth/auth.guard';
import { GlobalAdminGuard } from './guards/globaladmin/globaladmin.guard';

import { ImageUploadModule } from "angular2-image-upload";

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    HttpClientModule,
    ComponentsModule,
    LoginModule,
    ComprobantesModule,
    RouterModule,
    AppRoutingModule,
    JasperoAlertsModule,
    NgxUiLoaderModule,
    NgxUiLoaderHttpModule,
    ImageUploadModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'YOUR_GOOGLE_MAPS_API_KEY'
    })
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    LoginComponent,
    ComprobantesComponent
  ],
  providers: [
    AutoLogoutService,
    Session,
    Constants,
    DataService,
    AuthGuard,
    GlobalAdminGuard,
    AlertsService,
    IndicadoresService,
    APRService,
    UsuariosService,
    SociosService,
    CuentasService,
    RegionesService,
    LecturasService,
    ExternoService,
    PagosService,
    ModelosTarifariosService,
    GruposCuentasService,
    WebsocketService,
  ],
  bootstrap: [AppComponent],
  exports: [
    ReactiveFormsModule
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts